  <app-menu *axLazyElement="menuUrl" [items]="menuItems" [userInfo]="userInfo" [class.with-topbar]="isOneIdentity"></app-menu>
  <div class="topbar-wrapper" (resized)="onTopBarResized($event)" *ngIf="isOneIdentity" #topbarWrapper>
    <identity-topbar-component *axLazyElement="topbarUrl" [applicationName]="'Admin'" [claims]="null"
    (on-user-switch)="userSwitched($event)" (on-logout)="logout()"> </identity-topbar-component>
  </div>
  <div id="wallboardwrapper" class="wrapper" [style.margin-top.px]="topbarHeight"
    [style.height]="'calc(100vh - '+topbarHeight+'px)'">
      <div class="main">
        <div class="content">
          <router-outlet></router-outlet>
        </div>
      </div>
  </div>
  <app-messages></app-messages>
  <div id="dialogs-windows"></div>
  <div id="ddl-panel-wrapper"></div>
